import React, { useEffect } from 'react';
import InputType from './ComponentsTpes/InputType';

const OpenButton = ({  fieldsData, componentSourceOptions
     ,selectedPorts, setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Open_button:{
                    ...prevData.Open_button,
                    [key]: value
                }
            }
        })
    }

    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Open_button.component_source.value}
        condition={savedData.Open_button.condition}
        input={savedData.Open_button.input}
        name={savedData.Open_button.name}
        fieldsData={fieldsData}
    />)
}

export default OpenButton;